<div class="order-container" *ngIf="menu; else noMenu">
    <div class="header d-flex align-items-center justify-content-between mb-2">
        <div class="mx-1">
            <h5 class="mb-0">Tell us what you'd like</h5>
            <small class="text-muted">
                {{ menu.description || "We'll let the kitchen know ahead of your visit." }}
            </small>
        </div>
    </div>

    @if (requiredQuantity !== null) {
        <p aria-live="polite">Choose {{ requiredQuantity }} items in total, one per guest. {{ totalQuantity }} selected.</p>
    }
    <div class="list table-responsive">
        <table class="table align-middle mb-0">
            <thead>
                <tr>
                    <th scope="col" class="w-75">Product</th>
                    <th scope="col" class="text-end">Quantity</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items">
                    <td>
                        <div class="d-flex flex-column">
                            <span class="product-name">{{ item.name }}</span>
                            <small class="text-muted" *ngIf="item.description as d">
                                <span [innerHTML]="
                                isExpanded(item)
                                    ? d
                                    : (d | slice:0:characterLimit) + (d.length > characterLimit ? '...' : '')
                                ">
                                </span>
                                <button *ngIf="d.length > characterLimit" type="button"
                                    class="btn btn-sm btn-link p-0 ms-1 lh-base" (click)="toggleExpanded(item)">
                                    {{ isExpanded(item) ? 'Read less' : 'Read more' }}
                                </button>
                            </small>
                        </div>
                    </td>
                    <td class="text-end">
                        <div class="qty-pill d-inline-flex align-items-center ms-auto" aria-label="Quantity control"
                            appVenueColour [primaryColour]="availability.venue.primaryColour">
                            <span
                                class="pill-btn dec"
                                role="button"
                                tabindex="0"
                                [attr.data-testid]="'decrement-' + item.name"
                                (click)="decrementItem(item)"
                                [attr.aria-disabled]="getQuantity(item) === 0"
                                [class.disabled]="getQuantity(item) === 0"
                            >
                                −
                            </span>
                            <span
                                class="pill-qty fw-semibold"
                                aria-live="polite"
                                [attr.data-testid]="'quantity-' + item.name"
                            >
                                {{ getQuantity(item) }}
                            </span>
                            <span
                                class="pill-btn inc"
                                [attr.data-testid]="'increment-' + item.name"
                                role="button"
                                tabindex="0"
                                [attr.aria-disabled]="!canIncrement"
                                [class.disabled]="!canIncrement"
                                (click)="incrementItem(item)"
                            >
                                +
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="vstack mt-3">
        <button
            type="button"
            class="btn btn-primary"
            appVenueColour
            [primaryColour]="availability.venue.primaryColour"
            [disabled]="lineItemsFormArray.invalid || !validQuantity"
            (click)="confirmOrder()"
        >
            Continue
        </button>
    </div>
</div>

<ng-template #noMenu>
    <div class="alert alert-info mb-0">No add-ons available for this product.</div>
</ng-template>